<template>
    <div v-html="field.etiqueta"></div>
</template>

<script>
    export default {
        name: "Paragraph",
        props: ['field'],
    }
</script>

<style scoped>

</style>